import { useMemo } from 'react';
import styled from 'styled-components';
import Image from 'next/legacy/image';

import useI18n from '../../common/hooks/useI18n';

import Video from './video';

type Props = {
  query: string;
  className?: string;
};

const Title = styled.div`
  font-size: 20px;
  line-height: 130%;
  font-weight: 600;
  margin-top: 2.5rem;

  @media ${(props) => props.theme.breakpoints.smd} {
    font-size: 18px;
    margin-top: 1.5rem;
  }
`;

const Divider = styled.div`
  border: 1px solid ${(props) => props.theme.colors.primary};
  background-color: ${(props) => props.theme.colors.primary};
  width: 16px;
  margin-top: 16px;
  margin-left: auto;
  margin-right: auto;
`;

const Subtitle = styled.div`
  font-size: 18px;
  line-height: 32px;
  margin-top: 16px;
  margin-bottom: 32px;

  @media ${(props) => props.theme.breakpoints.lgd} {
    font-size: 16px;
  }
  @media ${(props) => props.theme.breakpoints.smd} {
    max-width: unset;
    line-height: 22px;
  }
`;

const FullVideoSection: React.FC<Props> = ({ query, className }) => {
  const i18n = useI18n();

  const subtitle = useMemo(
    () => i18n.t(`dynamic.sellHousePage.${query}.fullVideoSubtitle`),
    [i18n, query]
  );

  return (
    <div className={className}>
      <Image
        alt="arrows"
        width={40}
        height={40}
        src={`/images/sell_house/arrows.svg`}
      />

      <Title>{i18n.t(`dynamic.sellHousePage.${query}.fullVideoTitle`)}</Title>
      <Divider />
      <Subtitle
        key={subtitle.substring(0, 10) + new Date().getTime()}
        as="div"
        dangerouslySetInnerHTML={{
          __html: subtitle,
        }}
      />

      <Video url={i18n.t(`dynamic.sellHousePage.${query}.fullVideoUrl`)} />
    </div>
  );
};

export default styled(FullVideoSection)`
  text-align: center;
`;
